module.exports = __webpack_public_path__ + "static/img/bg-overview@w.99a1386.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hyundai-steel/bg-overview@w.jpg
// module id = TpSV
// module chunks = 0